import {
  and,
  DisplayProperties,
  EntityName,
  eq,
  FilterX,
  Query,
  ScopedProperties,
  toTuple,
} from '@debbie/common/dist/query/index.js'
import {
  AugmentedFilter,
  ViewDescription,
} from '@debbie/common/dist/views/index.js'
import * as db from '@debbie/common/dist/query/db.js'
import { baseContext, views } from './views.js'

export const convertFilter = (
  filter: AugmentedFilter,
): FilterX<typeof db.schema> => {
  return filter as FilterX<typeof db.schema>
}

export const toFilters = (
  filters: AugmentedFilter[],
): FilterX<typeof db.schema> | null => {
  if (filters.length === 0) {
    return eq('cases.deleted', false)
  } else if (filters.length === 1) {
    return and(convertFilter(filters[0]), eq('cases.deleted', false))
  }

  return and(
    ...(filters.map(convertFilter) as [
      FilterX<typeof db.schema>,
      FilterX<typeof db.schema>,
      ...FilterX<typeof db.schema>[],
    ]),
    eq('cases.deleted', false), // TODO: When multiple bases supported, detect if necessary
  )
}

export const genProperties = (
  base: EntityName,
  displayOptions: string[],
  preview: { header?: string; content?: string } | undefined,
): {
  properties: DisplayProperties<typeof db.schema>
  scopedProperties: ScopedProperties<typeof db.schema>
} => {
  let properties: Query<typeof db.schema, typeof base>['properties'] = {}

  if (baseContext[base] != null) {
    const [table, prop] = toTuple(baseContext[base].itemId)
    properties[table] = {
      // @ts-expect-error
      fields: [prop],
    }
  }

  let options = displayOptions.concat([])
  if (preview?.header != null) {
    options.push(preview.header)
  }
  if (preview?.content != null) {
    options.push(preview.content)
  }

  for (const option of options) {
    // @ts-expect-error
    const opt = views[option]
    if (opt == null) {
      console.log(views, option, opt)
    }
    if ('customDisplay' in opt) {
      for (const val of opt.values) {
        const [table, prop] = toTuple(val)
        // @ts-expect-error
        if (properties[table] == null) {
          // @ts-expect-error
          properties[table] = {
            fields: [prop],
          }
        } else {
          // @ts-expect-error
          properties[table].fields.push(prop)
        }
      }
      continue
    }
    // @ts-expect-error
    const [table, prop] = toTuple(views[option].value)
    // @ts-expect-error
    if (properties[table] == null) {
      // @ts-expect-error
      properties[table] = {
        fields: [prop],
      }
    } else {
      // @ts-expect-error
      properties[table].fields.push(prop)
    }
  }

  const scopedProperties: Query<typeof db.schema, typeof base>['scoped'] = {}

  for (const option of options) {
    const opt = views[option as keyof typeof views]
    if ('scopedProperties' in opt) {
      for (const table in opt.scopedProperties) {
        //@ts-expect-error
        for (const key in opt.scopedProperties[table]) {
          if (scopedProperties[table as EntityName] == null) {
            scopedProperties[table as EntityName] = {}
          }
          scopedProperties[table as EntityName]![key] =
            //@ts-expect-error
            opt.scopedProperties[table as EntityName][key]
        }
      }
    }
  }

  return { properties, scopedProperties }
}
